module.exports = __webpack_public_path__ + "img/IG1.8dec19d3.jpg";